/**
 * Gate sections the member cannot access.
 */

export default function({ to, from, store }) {
    let member = store.getters.member;
    if (member) {
        let pass = member.sections.find(s => {
            const routes = s.route.split(',').map(r => r.trim());
            const regexes = routes.map(r => new RegExp(`^${r.replace(/\*/g, '.*')}$`));
            return routes.includes(to.name) ||
                routes.some(r => r.replace(/\.\*$/, '') === to.name) ||
                regexes.some(rx => rx.test(to.name));
        });
        if (!pass) {
            return { name: 'dashboard' };
        }
    }
}
